/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import FieldTextBox from "../../../shared/controls/fieldTextBox";
import FieldCalendar from "../../../shared/controls/fieldCalendar";
import React, { useEffect, useReducer } from "react";
import formReducer from "../../../shared/forms/formReducer";
import SolicitudServicioValidacionEsquema from "./solicitudServicioValidacionEsquema";
import FormHandler from "../../../shared/forms/formHandler";
import useApiSolicitud from "../../../api/catalogos/useApiSolicitudServicio";
import FieldAutoComplete from "../../../shared/controls/fieldAutoComplete";
import moment from "moment";
import constantes from "../../constantes";
import ButtonIcon from "../../../shared/controls/ButtonIcon";
import produce from "immer";
import FieldDropDown from "../../../shared/controls/fieldDropDown";
import FieldTextArea from "../../../shared/controls/fieldTextArea";
const DetalleSolicitudServicio = ({
  onUpdateStatus,
  onSave,
  solicitudServicioId,
  ordenTrabajoId,
  closeSolicitud,
  soloLectura,
  defaultValues,
  ocultarOrdenesTrabajo,
  bloquearTipoServicio,
}) => {
  const apiSolicitud = useApiSolicitud();

  const defaultSolicitudServicio = () => ({
    entity: {
      id: 0,
      estatus: 0,
      patio: null,
      fechaSolicitud: moment().startOf("day").toDate(),
      ...(defaultValues ?? {}),
      fallas:
        defaultValues?.fallas?.length > 0
          ? defaultValues.fallas
          : [{ numeroFalla: 1 }],
    },
  });

  const [{ entity, errors, ...state }, dispatch] = useReducer(
    formReducer,
    defaultSolicitudServicio(),
  );

  useEffect(() => {
    let timer1 = setTimeout(loadSolicitudServicio, 100);
    return () => clearTimeout(timer1);
  }, [solicitudServicioId]);

  useEffect(() => {
    if (state.submitted === true) {
      formHandler.setValidacionSchema(
        SolicitudServicioValidacionEsquema.guardar,
      );
      formHandler.validate(entity);
    }
  }, [entity]);

  const loadSolicitudServicio = async () => {
    if (solicitudServicioId == null) return;

    if (solicitudServicioId === 0) {
      dispatch({ type: "reset", getDefault: defaultSolicitudServicio });
      return;
    }

    const resp = await apiSolicitud.obtener(solicitudServicioId);

    const apiResult = resp?.result ?? resp;
    const entityApi = apiResult?.entity ?? apiResult ?? {};
    const ordenesTrabajo = apiResult?.ordenesTrabajo ?? [];

    const entityFixed = {
      ...entityApi,
      fechaSolicitud: entityApi?.fechaSolicitud
        ? moment(entityApi.fechaSolicitud).toDate()
        : null,
      fechaProgramada: entityApi?.fechaProgramada
        ? moment(entityApi.fechaProgramada).toDate()
        : null,
      fechaCierre: entityApi?.fechaCierre
        ? moment(entityApi.fechaCierre).toDate()
        : null,
      ordenesTrabajo,
      fallas: entityApi?.fallas ?? [],
    };

    dispatch({ type: "reset", getDefault: () => ({ entity: entityFixed }) });
  };

  const update = (value, propertyName) => {
    dispatch({ type: "update", value, name: propertyName });
  };

  const formHandler = new FormHandler({
    validationSchema: SolicitudServicioValidacionEsquema.guardar,
    api: apiSolicitud,
    dispatch,
  });

  const save = async () => {
    const cartaPorteInt =
      entity.cartaPorte === "" || entity.cartaPorte == null
        ? 0
        : parseInt(entity.cartaPorte, 10);

    const empresaId =
      typeof entity?.empresaId === "object"
        ? (entity?.empresaId?.id ?? entity?.empresaId?.value ?? null)
        : (entity?.empresaId ?? null);

    const {
      bloquearTipoServicio,
      ocultarOrdenesTrabajo,
      ...entityParaGuardar
    } = entity;

    const solicitud = {
      ...entityParaGuardar,
      empresaId,
      cartaPorte: Number.isNaN(cartaPorteInt) ? 0 : cartaPorteInt,
      ordenTrabajoId: ordenTrabajoId ?? null,
    };

    const solicitudGuardado = await formHandler.save(solicitud, true);

if (formHandler.valdation.result === true && onSave) {
  onSave(solicitudGuardado, solicitud);
}

    return solicitudGuardado;
  };

  const cancelarSolicitud = async () => {
    if (!entity?.id || entity.id === 0) return;

    const confirmar = window.confirm(
      "¿Deseas cancelar esta solicitud de servicio?",
    );
    if (!confirmar) return;

    await apiSolicitud.cancelar(entity.id);

    if (onSave) onSave();
    if (closeSolicitud) closeSolicitud();
  };

  function agregarALista(lista) {
    const numeroFalla = lista.length + 1;
    const nuevo = produce(lista, (draft) => {
      draft.splice(numeroFalla, 0, { numeroFalla });
    });
    dispatch({ type: "update", value: nuevo, name: "fallas" });
  }

  function eliminarDeLista(lista, index) {
    const nuevo = produce(lista, (draft) => {
      draft.splice(index, 1);
    });
    dispatch({ type: "update", value: nuevo, name: "fallas" });
  }

  function actualizarLista(lista, index, value, propertyName) {
    const nuevo = produce(lista, (draft) => {
      draft[index][propertyName] = value;
    });
    dispatch({ type: "update", value: nuevo, name: "fallas" });
  }

  if (!entity) return null;

  return (
    <>
      <div className="form-container full-height">
        <div className="form-row">
          <h5 className="col-12">Detalle Solicitud</h5>

          <FieldCalendar
            name="fechaSolicitud"
            label="Fecha de Solicitud"
            className="small"
            showButtonBar={false}
            value={entity.fechaSolicitud}
            colMd={6}
            onChange={update}
            errors={errors}
            disabled
          />

          <FieldDropDown
            label="Empresa"
            name="empresaId"
            value={entity?.empresaId}
            colMd={6}
            source="empresas"
            onChange={update}
          />

          <FieldAutoComplete
            required
            name="solicitante"
            label="Nombre Solicitante"
            colMd={12}
            errors={errors}
            source="empleados"
            params={{ id: 0, todasLasEmpresas: true }}
            disabled={entity.id > 0}
            value={entity.solicitante}
            onChange={update}
          />

          <FieldAutoComplete
            required
            name="unidad"
            label="No Económico"
            colMd={6}
            errors={errors}
            source="unidades"
            params={{ id: 0, todasLasEmpresas: true }}
            disabled={entity.id > 0}
            value={entity.unidad}
            onChange={update}
          />

          <FieldTextBox
            name="tipoUnidad"
            disabled={true}
            errors={errors}
            value={entity.unidad?.tipoUnidad}
            label="Tipo Unidad"
            colMd={6}
            onChange={update}
          />
          <FieldDropDown
            name="patio"
            label="Patio"
            colMd={6}
            source="patios"
            value={entity?.patio ?? null}
            onChange={update}
            errors={errors}
          />
          <FieldTextBox
            name="cartaPorte"
            label="Carta Porte"
            value={entity.cartaPorte}
            colSm={6}
            onChange={update}
          />

          <FieldDropDown
            name="tipoServicio"
            label="Tipo de Servicio"
            colMd={8}
            source="tipoServicio"
            value={entity.tipoServicio}
            requiredIoDocumentText
            onChange={update}
            disabled={bloquearTipoServicio === true}
          />

          <FieldTextArea
            name="comentarios"
            label="Comentarios"
            value={entity.comentarios}
            colSm={12}
            onChange={update}
            rows={8}
          />
        </div>

        {ocultarOrdenesTrabajo !== true && (
          <div className="form-row">
            <h5 className="col-12">Detalle Orden de trabajo</h5>

            <table className="taller-detalle-solicitud table table-borderless">
              <thead className="thead-light">
                <tr>
                  <th style={{ width: "20%" }}>Orden de trabajo</th>
                  <th style={{ width: "30%" }}>Tipo mantenimiento</th>
                  <th style={{ width: "50%" }}>Nombre solicitante</th>
                </tr>
              </thead>

              <tbody>
                {entity.ordenesTrabajo?.length ? (
                  entity.ordenesTrabajo.map((ot, index) => (
                    <tr key={ot.ordenTrabajoId}>
                      <td className="input">
                        <FieldTextBox
                          name={`ordenTrabajoConsecutivo_${index}`}
                          disabled
                          value={ot.ordenTrabajoConsecutivo || ""}
                        />
                      </td>
                      <td className="input">
                        <FieldTextBox
                          name={`tipoMantenimiento_${index}`}
                          disabled
                          value={ot.tipoMantenimiento || ""}
                        />
                      </td>
                      <td className="input">
                        <FieldTextBox
                          name={`nombreSolicitanteOrdenTrabajo_${index}`}
                          disabled
                          value={ot.nombreSolicitanteOrdenTrabajo || ""}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3}>Sin orden(es) de trabajo asociada(s)</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        <table className="taller-detalle-solicitud table table-borderless">
          <thead className="thead-light">
            <tr>
              <th style={{ width: "5%" }}>Numero</th>
              <th style={{ width: "58%" }}>Descripcion</th>
              <th className="input" style={{ width: "10%" }}>
                {!soloLectura && (
                  <ButtonIcon
                    disabled={entity.id > 0}
                    title="Agregar Falla"
                    iconName="SiAddthis"
                    onClick={() => agregarALista(entity.fallas)}
                  />
                )}
              </th>
            </tr>
          </thead>

          <tbody>
            {entity.fallas?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td className="input">
                  <FieldTextBox
                    required
                    name="descripcion"
                    value={item.descripcion}
                    disabled={entity.id > 0}
                    errors={errors?.[`fallas[${index}]`]}
                    onChange={(value, pName) =>
                      actualizarLista(entity.fallas, index, value, pName)
                    }
                  />
                </td>
                <td className="input">
                  {!soloLectura && (
                    <ButtonIcon
                      title="Eliminar"
                      disabled={entity.id > 0 || entity.fallas.length === 1}
                      onClick={() => eliminarDeLista(entity.fallas, index)}
                      iconName="RiDeleteBinLine"
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="form-footer">
        <Button
          label="Cerrar"
          className="p-button-outlined"
          onClick={closeSolicitud}
        />

        {entity.id > 0 &&
          !soloLectura &&
          entity.estatus !== constantes.estatusSolicitudes.cerrada &&
          entity.estatus !== constantes.estatusSolicitudes.cancelado && (
            <Button
              label="Cancelar solicitud"
              className="p-button-danger"
              onClick={cancelarSolicitud}
            />
          )}

        {entity.estatus < constantes.estatusSolicitudes.programada &&
          !soloLectura && <Button label="Guardar" onClick={save} />}
      </div>
    </>
  );
};

export default DetalleSolicitudServicio;
